export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-23.dc9b2de9.png";